'use client'

import { JSX } from 'react'

import { RefreshCwIcon } from 'lucide-react'

import { Button, PageLayout } from '~/components/component-library'
import { EmptyState } from '~/components/component-library/EmptyState'

export function Custom404(): JSX.Element {
  return (
    <PageLayout>
      <EmptyState fullScreen title={<h1>404</h1>} className="mt-32">
        <p>Page not found. Please try refreshing the page.</p>
        <div className="inline-block">
          <Button
            variant={'secondary'}
            onClick={() => window.location.reload()}
            suffix={<RefreshCwIcon />}
          >
            Refresh page
          </Button>
        </div>
      </EmptyState>
    </PageLayout>
  )
}
